module.exports = __webpack_public_path__ + "img/Livewire.567c7fa1.png";